import { useRecordContext } from 'react-admin';

const CouponsMetaDataField = (props: any) => {
    const record = useRecordContext<any>();

    return (
        <div className="min-w-[200px] text-xs space-y-1">
            <p>
                <strong>Discount (%):</strong> {record?.discountInPercentage || 0}
            </p>
            <p>
                <strong>Discount (₹):</strong> ₹{record?.discountInPrice || 0}
            </p>
            <p>
                <strong>Max Discount (₹):</strong> ₹{record?.maxDiscountPrice || 0}
            </p>
            <p>
                <strong>Max Usage Per Student:</strong> {record?.maxUsageByPerStudent || '-'}
            </p>
            <p>
                <strong>Max Total Usages:</strong> {record?.maxTotalUsages || '-'}
            </p>
        </div>
    );
};

CouponsMetaDataField.defaultProps = {
    label: 'Coupon Details',
};

export default CouponsMetaDataField;
